/**
 * components/toastHost.web.tsx — web toast host. react-native-web's Modal
 * renders in a body portal at z-index 9999, so a toast in the normal tree sits
 * behind open modals. We portal the toast into its own body-level layer above
 * that, so toasts (incl. in-modal feedback) always render on top.
 */
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Toast from 'react-native-toast-message';
import { toastConfig } from './toastConfig';

export default function ToastHost() {
  const elRef = useRef<HTMLDivElement | null>(null);
  if (!elRef.current && typeof document !== 'undefined') {
    const d = document.createElement('div');
    d.style.position = 'fixed';
    d.style.inset = '0';
    d.style.zIndex = '2147483646';
    d.style.pointerEvents = 'none';
    elRef.current = d;
  }

  useEffect(() => {
    const el = elRef.current;
    if (!el) return undefined;
    document.body.appendChild(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  if (!elRef.current) return null;
  return createPortal(<Toast config={toastConfig} topOffset={28} />, elRef.current);
}
